var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { eo, Clone, ToJSON } from "js-vextensions";
import { CheckBox, Column, Pre, Row, Spinner, TextInput, Button, Select, TextArea, Text } from "react-vcomponents";
import { BaseComponent, GetDOM, BaseComponentPlus } from "react-vextensions";
import { SetBookEventIndex } from "Server/Commands/SetBookEventIndex";
import { UpdateBookEvent } from "Server/Commands/UpdateBookEvent";
import { GetEventIndex, GetEventWeekAndDay } from "Store/firebase/events";
import { BookEventStep } from "Store/firebase/events/@BookEvent";
import { GetSeed } from "Store/firebase/seeds";
import { MakeDraggable, Observer, RunInAction_Set } from "vwebapp-framework";
import { GetCharacters } from "Store/firebase/characters";
import { GetEventCharacters } from "Store/firebase/events/$event";
import { RemoveEventCharacter } from "Server/Commands/RemoveEventCharacter";
import { UpdateEventCharacterEntry } from "Server/Commands/UpdateEventCharacterEntry";
import { Droppable } from "react-beautiful-dnd";
import { ScrollView } from "react-vscrollview";
import { ShowMessageBox } from "react-vmessagebox";
import { DraggableInfo, DroppableInfo } from "Utils/UI/DNDStructures";
import { DeleteEventStep } from "Server/Commands/DeleteEventStep";
import { store } from "Store";
let EventDetailsPanel = class EventDetailsPanel extends BaseComponentPlus({}, { addChar_selected: null }) {
    render() {
        const { event, character } = this.props;
        if (event == null || character == null)
            return React.createElement(Column, { ml: 10, style: { flex: 50, padding: 5 } }); // just fill space
        const seed = GetSeed(event.seed);
        const characters = GetCharacters(character.book);
        const eventCharacters = GetEventCharacters(event);
        const eventCharacters_indexes = GetEventCharacters(event).map(char => GetEventIndex(char ? char._key : null, event._key));
        const { addChar_selected } = this.state;
        const { week, day } = GetEventWeekAndDay(event, character.book, character._key);
        const { week: inferredWeek, day: inferredDay } = GetEventWeekAndDay(event, character.book, character._key, true);
        const nonEventCharacters = characters.filter(a => !eventCharacters.Any(b => b._key == a._key));
        const text = event.text || (seed || eo).text;
        return (React.createElement(ScrollView, { style: { marginLeft: 5, flex: 50, height: "100%", padding: "5px 10px 5px 5px", background: "rgba(0,0,0,.7)", borderRadius: 10, boxShadow: "rgba(0,0,0,1) 0px 0px 2px" } },
            React.createElement(Row, { center: true, mt: 5 },
                React.createElement(Pre, null,
                    "ID: ",
                    event._key),
                React.createElement(Pre, { ml: 5 }, "Seed: "),
                React.createElement(Spinner, { value: event.seed || 0, onChange: val => {
                        new UpdateBookEvent({ id: event._key, updates: { seed: val != 0 ? val : undefined } }).Run();
                    } })),
            React.createElement(Row, { center: true, mt: 5 },
                React.createElement(Pre, null, "Text: "),
                React.createElement(TextArea, { value: text, delayChangeTillDefocus: true, useEscape: true, autoSize: true, style: { flex: 1 }, onChange: val => {
                        new UpdateBookEvent({ id: event._key, updates: { text: val } }).Run();
                    } })),
            React.createElement(Row, { center: true, mt: 5 },
                React.createElement(CheckBox, { text: "Week: ", value: event.week != null, onChange: val => {
                        new UpdateBookEvent({ id: event._key, updates: { week: val ? (week || 0) : null } }).Run();
                    } }),
                React.createElement(Spinner, { enabled: event.week != null, value: event.week || 0, min: 0, style: { width: 70 }, onChange: val => {
                        new UpdateBookEvent({ id: event._key, updates: { week: val } }).Run();
                    } }),
                React.createElement(CheckBox, { ml: 5, text: "Day: ", value: event.day != null, onChange: val => {
                        new UpdateBookEvent({ id: event._key, updates: { day: val ? (day || 0) : null } }).Run();
                    } }),
                React.createElement(Spinner, { enabled: event.day != null, value: event.day || 0, min: 1, max: 7, style: { width: 70 }, onChange: val => {
                        new UpdateBookEvent({ id: event._key, updates: { day: val } }).Run();
                    } }),
                React.createElement(Pre, { ml: 5 },
                    "Final week.day: ",
                    React.createElement(Pre, { style: { color: "green" } },
                        week != null ? week : "?",
                        ".",
                        day != null ? day : "?")),
                eventCharacters.Except(character).map(char => {
                    const weekForChar = GetEventWeekAndDay(event, character.book, char._key).week;
                    const dayForChar = GetEventWeekAndDay(event, character.book, char._key).day;
                    return React.createElement(Pre, { key: char._key },
                        ", ",
                        char.name,
                        ": ",
                        React.createElement(Pre, { style: { color: weekForChar == week && dayForChar == day ? "green" : "red" } },
                            weekForChar != null ? weekForChar : "?",
                            ".",
                            dayForChar != null ? dayForChar : "?"));
                })),
            React.createElement(Column, { mt: 5 },
                React.createElement(Row, { center: true },
                    React.createElement(Pre, null, "Characters involved: "),
                    React.createElement(Button, { enabled: nonEventCharacters.length > 0 && addChar_selected != null, p: "3px 10px", text: "Add: ", onClick: () => {
                            //new AddEventCharacter({eventID: event._key, characterID: addChar_selected}).Run();
                            new UpdateBookEvent({ id: event._key, updates: { [`characters/${addChar_selected}`]: { _: true } } }).Run();
                        } }),
                    React.createElement(Select, { ml: 5, options: [{ name: "", value: null }].concat(nonEventCharacters.map(a => ({ name: a.name, value: a._key }))), value: addChar_selected, onChange: val => {
                            this.SetState({ addChar_selected: val });
                        } })),
                eventCharacters.map((char, charIndex) => {
                    if (char == null)
                        return React.createElement(Row, null);
                    return (React.createElement(Row, { center: true, key: char._key },
                        React.createElement(Button, { text: "X", onClick: () => {
                                ShowMessageBox({
                                    title: `Detach character "${char.name}"?`,
                                    message: "Detach character from this event? Step-data for character will remain, but requires re-attachment of character to view.", cancelButton: true,
                                    onOK: () => {
                                        new RemoveEventCharacter({ eventID: event._key, characterID: char._key }).Run();
                                    },
                                });
                            } }),
                        React.createElement(Pre, { ml: 5 },
                            char.name,
                            " -- "),
                        React.createElement(Pre, null, "Main: "),
                        React.createElement(CheckBox, { value: event.characters[char._key].main, onChange: val => {
                                new UpdateEventCharacterEntry({ eventID: event._key, characterID: char._key, updates: { main: val || null } }).Run();
                            } }),
                        React.createElement(Pre, null, "Order: "),
                        React.createElement(Spinner, { value: eventCharacters_indexes[charIndex] || undefined, style: { width: 70 }, onChange: val => {
                                new SetBookEventIndex({ characterID: char._key, eventID: event._key, index: val, removeBeforeInsert: true }).Run();
                            } })));
                }),
                React.createElement(Row, { mt: 5 })),
            React.createElement(Row, null,
                React.createElement(Text, null, "Show:"),
                React.createElement(CheckBox, { ml: 5, text: "Action grid", value: store.main.write.events_actionGridVisible, onChange: val => RunInAction_Set(this, () => store.main.write.events_actionGridVisible = val) }),
                React.createElement(CheckBox, { ml: 5, text: "Text", value: store.main.write.events_textVisible, onChange: val => RunInAction_Set(this, () => store.main.write.events_textVisible = val) })),
            React.createElement(Row, { mt: 5, style: { flex: 1 } },
                store.main.write.events_actionGridVisible &&
                    React.createElement(Column, { style: { flex: 1, height: "100%", paddingBottom: 1000 } },
                        React.createElement(ActionsGrid, { event: event })),
                store.main.write.events_textVisible &&
                    React.createElement(Column, { ml: 5, style: { flex: 1 /*height: "100%"*/ } },
                        React.createElement(TextArea, { value: event.fullText, delayChangeTillDefocus: true, useEscape: true, style: { flex: 1, whiteSpace: "" }, onChange: val => {
                                new UpdateBookEvent({ id: event._key, updates: { fullText: val } }).Run();
                            } })))));
    }
};
EventDetailsPanel = __decorate([
    Observer
], EventDetailsPanel);
export { EventDetailsPanel };
let ActionsGrid = class ActionsGrid extends BaseComponentPlus({}, {}) {
    render() {
        const { event } = this.props;
        const characters = GetEventCharacters(event);
        const steps = event.steps || [];
        const droppableInfo = new DroppableInfo({ type: "ActionsGrid", eventID: event._key });
        return (React.createElement(Column, null,
            React.createElement(Row, null,
                React.createElement("div", { style: { width: 40 } }),
                characters.map((char, index) => {
                    return (React.createElement("div", { key: index, style: { flex: 1, textAlign: "center", background: "rgba(255,255,255,.2)", border: "1px solid rgba(255,255,255,.3)" } }, char.name));
                }),
                React.createElement("div", { style: { width: 40 } })),
            React.createElement(Droppable, { type: "BookEventStep", droppableId: ToJSON(droppableInfo) }, (provided, snapshot) => (React.createElement(Column, { ref: c => provided.innerRef(GetDOM(c)), style: { flex: 1 } },
                steps.map((step, index) => {
                    return React.createElement(ActionGridStep, { key: index, step: step, index: index, event: event, characters: characters });
                }),
                provided.placeholder))),
            React.createElement(Row, null,
                React.createElement(Button, { text: "+", onClick: () => {
                        const newStep = new BookEventStep();
                        /*const newSteps = Clone(steps);
                        newSteps.push(newStep);
                        new UpdateBookEvent({id: event._key, updates: {steps: newSteps}}).Run();*/
                        //new AddEventStep({eventID: event._key, step: newStep}).Run();
                        new UpdateBookEvent({ id: event._key, updates: { [`steps/${steps.length}`]: newStep } }).Run();
                    } }))));
    }
};
ActionsGrid = __decorate([
    Observer
], ActionsGrid);
let ActionGridStep = class ActionGridStep extends BaseComponent {
    render() {
        const { step, index, event, characters, dragInfo } = this.props;
        return (React.createElement(Row, Object.assign({}, (dragInfo && dragInfo.provided.draggableProps), (dragInfo && dragInfo.provided.dragHandleProps)),
            React.createElement(Button, { className: "notFocusTarget", style: { width: 40 }, text: "*", title: "Drag this to reorder the step" }),
            characters.map((char, charIndex) => {
                const action = step.actions[char._key];
                return (React.createElement(TextInput, { key: charIndex, style: { flex: 1 }, delayChangeTillDefocus: true, value: action ?? "", onChange: val => {
                        /*const val_final = val && val.trim().length ? val : null;
                        if (val_final == action) return; // if action-text unchanged, return*/
                        const newStep = Clone(step);
                        //newStep.actions[char._key] = val_final;
                        //if (val_final) newStep.actions[char._key] = val_final;
                        if (val && val.trim().length)
                            newStep.actions[char._key] = val;
                        else
                            delete newStep.actions[char._key];
                        /*const newSteps = Clone(event.steps);
                        newSteps[index] = newStep;
                        //if (ToJSON(newSteps) != ToJSON(event.steps)) {
                        new UpdateBookEvent({id: event._key, updates: {steps: newSteps}}).Run();*/
                        new UpdateBookEvent({ id: event._key, updates: { [`steps/${index}`]: newStep } }).Run();
                    } }));
            }),
            React.createElement(Button, { style: { width: 40 }, text: "X", onClick: () => {
                    ShowMessageBox({
                        title: "Delete step?",
                        message: "This will delete the current step (row) from the action-grid.",
                        cancelButton: true,
                        onOK: () => {
                            /*const newSteps = CloneWithPrototypes(event.steps);
                            newSteps.RemoveAt(index);
                            new UpdateBookEvent({id: event._key, updates: {steps: newSteps}}).Run();*/
                            new DeleteEventStep({ eventID: event._key, stepIndex: index }).Run();
                        },
                    });
                } })));
    }
};
ActionGridStep = __decorate([
    MakeDraggable((props) => {
        const { step, index } = props;
        return {
            type: "BookEventStep",
            draggableInfo: new DraggableInfo({ stepIndex: index }),
            //draggableInfo: new DraggableInfo({}),
            index,
        };
    })
], ActionGridStep);
